import { gql } from "@apollo/client";

const GET_FLOOR_PLAN =
  gql(`query FloorPlan ($bookingModuleId: ID!) {
  floorPlan (bookingModuleId: $bookingModuleId) {
    floorPlanData
  }
}`);

const GET_CUSTOMER_PLAN =
  gql(`query FloorPlan ($bookingModuleId: ID!) {
  floorPlan (bookingModuleId: $bookingModuleId) {
    customerPlanData
  }
}`);

const GET_FLOORPLANS =
  gql(`query FloorPlan ($bookingModuleId: ID!) {
  floorPlan (bookingModuleId: $bookingModuleId) {
    floorPlanData,
    customerPlanData
  }
}`);

export {
    GET_FLOORPLANS, GET_FLOOR_PLAN, GET_CUSTOMER_PLAN
};
